module.exports = __webpack_public_path__ + "img/VF7.bc8ade3f.png";